import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from '@nuxtjs/composition-api';
import HeaderMainMenuMobileItem from '@/domains/menus/components/HeaderMainMenuMobileItem.vue';

interface Props {
  value?: boolean;
  menu?: any[];
}
interface Emits {
  (e: 'toggle-menu'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMainMenuMobile',
  props: {
    value: { type: Boolean, default: false },
    menu: { default: () => [] }
  },
  emits: ["toggle-menu"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle-menu'): void;
}), expose: any, slots: any, attrs: any }) {




const activeCategory = ref<any | null>(null);
const activeCategoryList = ref<any[]>([]);

const openCategory = (category: any) => {
  activeCategoryList.value.push(category);
  activeCategory.value = category;
};

const closeCategory = () => {
  if (activeCategoryList.value.length) {
    const lastIndex = activeCategoryList.value.length - 1;
    // Delete last category
    activeCategoryList.value.pop();
    activeCategory.value = activeCategoryList.value[lastIndex - 1];
  } else {
    activeCategory.value = null;
  }
};

const closeMenu = () => {
  activeCategory.value = null;
  activeCategoryList.value = [];
  emit('toggle-menu');
};

const areLastChildren = computed(() => {
  return activeCategory.value?.children.every((child: any) => !child.children);
});

return { __sfc: true,emit, activeCategory, activeCategoryList, openCategory, closeCategory, closeMenu, areLastChildren, HeaderMainMenuMobileItem }
}

})